<template>
  <transition name="bottomSlide" appear>
    <div class="footer">
      <div
        class="footer__menu"
        :class="{
          'footer__menu--id' : isLoggedIn && Number(subscInfo.active) === 0,
          'footer__menu--subsc' : isLoggedIn && Number(subscInfo.active) !== 0,
          }"
      >
        <template v-for="(menu,index) in menuList">
          <div v-if="!menu.isFooterHidden" :key="menu.title" class="footer__menu__item" @click="selectMenu(index)">
            <IconBase class="footer__menu__icon" v-if="menu.iconComponent" :name="menu.iconComponent" :color="isPc ? '#FF7497' :'#FFF'" />
            <img v-if="menu.iconSrc" :src="menu.iconSrc" />
            <span>{{ menu.title }}</span>
          </div>
        </template>
      </div>
      <FooterModal v-if="isShowModal" :menuList="selectList" @close="modalToggle(false)"/>
      <Overlay v-if="isShowModal && !isPc"/>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { MENU } from './const.js'
import * as type from '@/utvStore/store/mutation-types'
import FooterModal from './FooterModal'
import Overlay from './Overlay'
import IconBase from './icon/IconBase'

export default {
  name: 'NavigationFooter',
  components:{
    FooterModal,
    Overlay,
    IconBase
  },
  data() {
    return {
      userType:'subsc',
      isShowModal:false,
      selectIdx:0,
      selectList:[]
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      subscInfo: state => state.account.subscription,
      isPc: state => state.uiState.isPc,
      showAccountModal: state => state.uiState.showAccountModal,
      showDrawerMenu: state => state.uiState.showDrawerMenu,
      showFooterMenu: state => state.uiState.showFooterMenu,
    }),
    menuList(){
      return !this.isLoggedIn ? MENU.NO_MEMBER : !!parseInt(this.subscInfo.active) ? MENU.SUBSC : MENU.ID
    },
  },
  watch:{
    showAccountModal(isShow){
      //PCの場合アカウントメニューが開いたらサイドメニューを閉じる
      if(isShow && this.isPc) this.modalToggle(false)
    },
    showDrawerMenu(isShow){
      //PCの場合ドロワーメニューが閉じられたらサイドメニューも閉じる
      if(!isShow && this.isPc) this.modalToggle(false)
    },
    showFooterMenu(isShow){
      this.isShowModal = isShow
    }
  },
  methods: {
    selectMenu(index){
      if(this.isShowModal && this.selectIdx === index){
        //モーダル開いた状態で選択中のアイコンがもう一度押下されたら閉じる
        this.modalToggle(false)
        return
      }

      if(!this.menuList[index].children && this.menuList[index].url){
        //子要素がなくURLが設定されている場合はボタン押下時に遷移 モーダルが開いていたら閉じる
        this.modalToggle(false)
        location.href = this.menuList[index].url
      }else{
        // 子要素がある場合はモーダルopen
        this.$set(this.selectList, 0, this.menuList[index])
        this.modalToggle(true)
        this.selectIdx = index
      }
    },
    modalToggle(isOpen){
      //PCの場合サイドメニュー（フッター）が開いたらアカウントメニューは閉じる
      if(this.isPc && isOpen) this.$store.dispatch(type.ACCOUNT_MODAL_VISIBILITY, false)
      this.$store.dispatch(type.FOOTER_MENU_VISIBILITY, isOpen)
      this.isShowModal = isOpen
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.footer{
  position: fixed;
  bottom:0;
  left: 0;
  height: fit-content;
  width: 100vw;
  z-index: 90001;
  box-shadow: 0px -5px 15px rgba(0, 0, 0, 0.15);
  @include mq('pc') {
    width: 75px;
    height: 100%;
    top: 44px;
  }

  &__menu{
    height: 50px;
    width: 100%;
    background: $col_def_gradient;
    padding: 2px 14% 0;
    display: flex;
    justify-content: space-around;
    position: relative;
    z-index: 90004;
    @include mq('pc') {
      height: 100%;
      flex-direction: column;
      justify-content: flex-start;
      background: $col_white;
      padding: 7px 0;
    }


    &--id{
      padding: 2px 6% 0;
      @include mq('pc') {
        padding: 7px 0;
      }
    }
    &--subsc{
      padding: 2px 0 0;
      @include mq('pc') {
        padding: 7px 0;
      }
    }

    &__item{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 60px;
      cursor: pointer;
      @include mq('pc') {
        width: 100%;
        height: 75px;
        &:hover,&:active{
          background: linear-gradient(59.75deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
        }
      }

      span{
        font-size: 10px;
        line-height: 15px;
        color: $col_white;
        font-weight: bold;
        margin-top: 3px;
        @include mq('pc') {
          color: $col_temp_key1;
        }
      }
    }
  }
}
.bottomSlide-enter-active, .bottomSlide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.bottomSlide-enter, .bottomSlide-leave-to {
  transform: translateY(100vh) translateY(0px);
  @include mq('pc') {
    transform: translateX(-100vw) translateX(0px);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/NavigationFooter.vue